/* eslint-disable @atlaskit/platform/inline-usage -- This temporary strangler intentionally wraps the old and new experiment APIs during migration. */
import { isExperimentEnabled as platformIsExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';

/**
 * Temporary strangler for boolean editor experiments using the conventional `isEnabled` param.
 * The legacy callback is evaluated only while the migration gate is off.
 *
 * For experiments with multiple product keys, OR one call per unique product key. Pass the real
 * legacy callback only to the first call and `() => false` to the remaining calls so the fallback
 * is evaluated at most once.
 * Migrate callers to `@atlaskit/platform-feature-experiments/is-experiment-enabled` when the
 * transition gate is removed.
 */
export function isExperimentEnabled(experimentName: string, legacyValue: () => boolean): boolean {
	if (fg('platform_editor_use_new_experiments_api')) {
		return platformIsExperimentEnabled(experimentName);
	}

	return legacyValue();
}
